import React from "react";
import PoolInfoCard from "./PoolInfoCard";

const PoolInfoGrid = ({ villa }) => {
  return (
    <div className="grid sm:grid-cols-3 ml:grid-cols-2 grid-cols-1 gap-2.5">
      <PoolInfoCard
        title="Dış Havuz"
        poolType={villa.yuzme_havuzu.replace(/ /g, "")}
        width={villa.yuzme_havuzu_genislik}
        length={villa.yuzme_havuzu_uzunluk}
        depth={villa.yuzme_havuzu_derinlik.replace(/ /g, "")}
      />
      <PoolInfoCard
        title="Kapalı Havuz"
        poolType={villa.kapali_havuz.replace(/ /g, "")}
        width={villa.kapali_havuz_genislik}
        length={villa.kapali_havuz_uzunluk}
        depth={villa.kapali_havuz_derinlik.replace(/ /g, "")}
      />
      <PoolInfoCard
        title="Çocuk Havuzu"
        poolType={villa.cocuk_havuzu.replace(/ /g, "")}
        width={villa.cocuk_havuzu_genislik}
        length={villa.cocuk_havuzu_uzunluk}
        depth={villa.cocuk_havuzu_derinlik.replace(/ /g, "")}
      />
    </div>
  );
};

export default PoolInfoGrid;
